module.exports = __webpack_public_path__ + "img/service-comerce.7122e254.svg";